<!-- ProductoExpand.svelte -->

<script>
	
	export let item= {}
	export let visible=false
	export let idx = 0

	$: images =  item.imagenes.split(",") || 'upm.jpeg'

	function next_image(){
		if((images.length-1) > idx) idx++
		else idx=0
	}
	function prev_image(){
		if(idx>0) idx--
		else idx=images.length-1
	}
</script>

<!-- on:click|self="{()=>visible=false}"	 -->
<div class="modal" >
<div class="w-full " on:click|self={()=>visible=false}  style="width:100%;display:flex;align-items:center;justify-content:center;z-index:50;background-color:white;">
	<button class="secondary" style="position:absolute;top:10px;right:20px;border-radius:40%;font-size:20px;"
			on:click="{()=>visible=false}" ><strong>&Cross;</strong></button>
	<div class="">

		<button on:click="{prev_image}" class="inverse" style="position: absolute;top:40%;left:0px;">&laquo;</button>
		<img src={'upload/'+images[idx]} alt="" xclass="mx-auto w-full" style="height:80%;">
		<button on:click="{next_image}"  class="inverse" style="position: absolute;top:40%;right:10px;">&raquo;</button>
		
		<!-- <p class="text-gray-300 text-xs text-right">#{item.id}</p>
		<div class="mt-1 pl-4 align-end">
			<p class="text-xs font-bold">{item.nombre}</p>
			<p class="text-sm w-full">{item.descrp}</p>
			<p class="font-bold">{item.importe1}</p>
		</div>
		{#if idx>0}
			<button on:click="{prev_image}" class="absolute top-1/4 left-1 text-white font-bold py-1 px-3 border border-white rounded">&laquo;</button>
		{/if}
		{#if (images.length-1)>idx}
			<button on:click="{next_image}" class="absolute top-1/4 right-1 text-white font-bold py-1 px-3 border border-white rounded">&raquo;</button>
		{/if}
		<button on:click="" class="absolute top-2 right-1 text-white font-bold py-1 px-3 border border-white rounded" title="Ver Detalles">&nearhk;</button>
		<p>{idx} / {images.length}</p>

		 -->
	</div>
</div>
</div>
